<div class="m-3 d-flex flex-column gap-3">
  <shared-ui-cards-card>
    <div class="row">
      <shared-ui-inputs-input-group
        [parentFormGroup]="searchOptionsFormGroup"
        (keyup.enter)="search()"
        [name]="'list-files-search-name' | translate"
        [formName]="'search'"
        [appendElements]="[searchBtn, filterBtn]"
        [showLabel]="false"
      >
        <ng-template #searchBtn>
          <shared-ui-buttons-button [text]="'list-evidence-search-evidence-button' | translate" [icon]="iconType.Search" (action)="search()"></shared-ui-buttons-button>
        </ng-template>
        <ng-template #filterBtn>
          <shared-ui-buttons-button
            [icon]="iconType.Filter"
            [text]="'button-more-filters' | translate"
            [title]="'button-more-filters' | translate"
            [iconTooltip]="'button-more-filters' | translate"
            (action)="hideFilter = !hideFilter"
            *ngIf="showOfficerFilter || showEvidenceFilter || showCategoryFilter || showDateFilter"
          >
          </shared-ui-buttons-button>
        </ng-template>
      </shared-ui-inputs-input-group>
    </div>
    <div [hidden]="hideFilter">
      <div class="row mt-3">
        <div class="col-md-6 col-lg-3" *ngIf="showOfficerFilter">
          <shared-ui-inputs-select-group
            [options]="officerFilterData"
            [parentFormGroup]="searchOptionsFormGroup"
            [name]="'select-field-file-uploaded-by' | translate"
            [formName]="'officer'"
            [resettable]="true"
            [filter]="true"
            [setDefaultValue]="false"
            [multiple]="true"
            [placeholder]="'select-placeholder-all' | translate"
          >
          </shared-ui-inputs-select-group>
        </div>
        <div class="col-md-6 col-lg-3" *ngIf="showEvidenceFilter">
          <shared-ui-inputs-select-group
            [options]="typeList"
            [parentFormGroup]="searchOptionsFormGroup"
            [name]="'file-type-label' | translate"
            [formName]="'type'"
            [resettable]="true"
            [filter]="true"
            [setDefaultValue]="false"
            [multiple]="true"
            [placeholder]="'select-placeholder-all' | translate"
          >
          </shared-ui-inputs-select-group>
        </div>
        <div class="col-md-6 col-lg-3" *ngIf="showCategoryFilter">
          <shared-ui-inputs-select-group
            [options]="categoriesList"
            [parentFormGroup]="searchOptionsFormGroup"
            [name]="'select-field-file-categories' | translate"
            [formName]="'categories'"
            [resettable]="true"
            [filter]="true"
            [setDefaultValue]="false"
            [multiple]="true"
            [placeholder]="'select-placeholder-all' | translate"
          >
          </shared-ui-inputs-select-group>
        </div>
        <div class="col-md-6 col-lg-3" *ngIf="showDateFilter">
          <div class="form-group">
            <label class="form-label fw-bold">{{ 'list-evidence-date-filter-name' | translate }}</label>
            <div class="d-flex m-b prime-input-group">
              <shared-ui-inputs-select-field
                class="no-right-border"
                [options]="dateRangeSearchOptions"
                [parentFormGroup]="searchOptionsFormGroup"
                [formName]="'date'"
                [resettable]="false"
              ></shared-ui-inputs-select-field>
              <shared-ui-datetime-range-picker-popup
                append
                class="w-100"
                [formControlVariableName]="searchOptionsFormGroup.controls.range"
                [formControlSearchTerm]="searchOptionsFormGroup.controls.selectedSearchRangeTerm"
                (dateFilter)="dateFilterChanged($event)"
              ></shared-ui-datetime-range-picker-popup>
            </div>
          </div>
        </div>
      </div>
    </div>
  </shared-ui-cards-card>

  <shared-ui-cards-card>
    <shared-ui-tables-simple-table
      *featureLoadingTableSkeleton="
        columns.length;
        columnNames: columns;
        isLoading: ((initialization$ | async) ?? false) ||
          ((onlySharedWithMe ? (listEvidenceFacade.isLoadingSharedWithMe() | async) : (listEvidenceFacade.getIsLoadingEvidence() | async)) ?? false)
      "
      (pageChange)="pageChanged($event)"
      [columns]="columns"
      [data]="data"
      (dataOrdered)="order($event)"
      [noDataText]="'message-table-list-files-empty' | translate"
      (doubleClick)="onDoubleClick($event)"
    >
      <ng-template #templateHeader let-colData>
        <ng-template [ngTemplateOutlet]="templateHeaderOuter" [ngTemplateOutletContext]="{ $implicit: colData }"> </ng-template>
      </ng-template>
      <ng-template #template let-data>
        <ng-template [ngTemplateOutlet]="templateOuter" [ngTemplateOutletContext]="{ $implicit: data }"> </ng-template>
      </ng-template>
    </shared-ui-tables-simple-table>
  </shared-ui-cards-card>
</div>
